var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$eventBusUtility.navigateTo('notifications')}}},[_c('v-badge',{attrs:{"right":"","overlap":"","color":"green","content":_vm.notificationCount,"value":_vm.notificationCount}},[_c('v-icon',[_vm._v("mdi-bell-outline")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }